<div id="page-container">
  <div id="content-wrap">
    <img
      src="../../assets/images/Logos/apra_econnection_logo.png"
      class="logo"
    />
    <div class="content">
      <div class="archive">
        <h1>Recent E-Connections</h1>
<!-- e-connection.component.html — mailList section -->
<div class="mailList">
  <a *ngFor="let e of eConnections; let i = index"
     [routerLink]="[i]"
     routerLinkActive="active"
     class="mailItem">
    <span>{{ e.date }}</span>
  </a>
</div>

<router-outlet></router-outlet>
      </div>
      <div class="eConnectionForm" id="requestForm">
        <h3>eConnection Registration Form</h3>
        <form #userForm="ngForm" (ngSubmit)="submitRequest(userForm)">
          <div class="formGroup">
            <label>First Name*</label>
            <input
              type="text"
              required
              ngModel
              #FirstName="ngModel"
              name="FirstName"
            />
            <div class="required" *ngIf="FirstName.touched && !FirstName.valid">
              First Name is required
            </div>
          </div>
          <div class="formGroup">
            <label>Last Name*</label>
            <input
              type="text"
              required
              ngModel
              #LastName="ngModel"
              name="Last Name"
            />
            <div class="required" *ngIf="LastName.touched && !LastName.valid">
              Last Name is required
            </div>
          </div>
          <div class="formGroup">
            <label>Email Address*</label>
            <input
              type="email"
              required
              ngModel
              email
              #Email="ngModel"
              name="Email"
            />
            <div class="required" *ngIf="Email.touched && !Email.valid">
              Valid Email Address is required
            </div>
          </div>

          <button>Submit</button>
        </form>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
